import { render, staticRenderFns } from "./ErrorSummary.vue?vue&type=template&id=2f3d6f36"
import script from "./ErrorSummary.vue?vue&type=script&lang=js"
export * from "./ErrorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports